import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { FaSearch, FaTimes, FaFileExcel, FaCalendarAlt } from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import moment from 'moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { default as Selector } from 'react-select';
import { toast } from 'react-toastify';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { MASK_DATE } from '~/constant';
import Entregues from './Entregues';
import Clientes from './Clientes';
import Estoque from './Estoque';
import Configuracoes from './Configuracoes';
import {
  buscarRelatorioAdministracaoBrinde,
  buscarOpcoesFiltrosBrinde,
} from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';

const MOVIMENTACAO_OPTIONS = [
  { value: 'Inclusão', label: 'Inclusão' },
  { value: 'Edição', label: 'Edição' },
  { value: 'Exclusão', label: 'Exclusão' },
];

const CONFIGURACAO_OPTIONS = [
  { value: 'Localidades', label: 'Localidades' },
  { value: 'Estoque', label: 'Estoque' },
  { value: 'Parâmetros', label: 'Parâmetros' },
  { value: 'Entrega', label: 'Entrega' },
];

const colunas = [
  { title: 'Data', key: 'data_movimentacao', ordenacao: true, width: '150px', align: 'center' },
  { title: 'Tipo Movimentação', key: 'tipo_movimentacao', ordenacao: true },
  { title: 'Tipo Configuração', key: 'tipo_configuracao', ordenacao: true },
  { title: 'Descrição', key: 'descricao' },
  { title: 'Usuário', key: 'usuario', ordenacao: true },
];

const getTabs = () => {
  const baseTabs = [
    { key: 'geral', label: 'Adm. Geral' },
    { key: 'entregues', label: 'Entregues' },
    { key: 'clientes', label: 'Clientes' },
    { key: 'estoque', label: 'Estoque' },
  ];

  if (AuthStorage.temCaracteristica(609) || AuthStorage.isADM()) {
    baseTabs.push({ key: 'configuracoes', label: 'Configurações' });
  }

  return baseTabs;
};

const ControleBrindes = () => {
  const [activeTab, setActiveTab] = useState('geral');
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [openPickerInicial, setOpenPickerInicial] = useState(false);
  const [openPickerFinal, setOpenPickerFinal] = useState(false);
  const [movimentacao, setMovimentacao] = useState([]);
  const [configuracao, setConfiguracao] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [dados, setDados] = useState([]);
  const [opcoesUsuario, setOpcoesUsuario] = useState([]);

  useEffect(() => {
    const carregarOpcoes = async () => {
      try {
        const opcoes = await buscarOpcoesFiltrosBrinde();
        setOpcoesUsuario(
          (opcoes.usuarios || []).map(u => ({ value: u.valor, label: u.label }))
        );
      } catch {
        toast.error('Erro ao carregar opções de filtros.');
      }
    };
    carregarOpcoes();
  }, []);

  const handleLimparFiltros = () => {
    setDataInicial('');
    setDataFinal('');
    setMovimentacao([]);
    setConfiguracao(null);
    setUsuario(null);
  };

  const handleBuscar = async () => {
    try {
      const filtros = {};
      if (dataInicial && moment(dataInicial, 'DD/MM/YYYY', true).isValid())
        filtros.data_inicial = moment(dataInicial, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (dataFinal && moment(dataFinal, 'DD/MM/YYYY', true).isValid())
        filtros.data_final = moment(dataFinal, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (movimentacao.length === 1)
        filtros.tipo_movimentacao = movimentacao[0].value;
      if (configuracao)
        filtros.tipo_configuracao = configuracao.value;
      if (usuario)
        filtros.codigo_usuario = usuario.value;

      const resultado = await buscarRelatorioAdministracaoBrinde(filtros);
      const dadosFormatados = (resultado || []).map(item => ({
        ...item,
        data_movimentacao: item.data_movimentacao
          ? moment(item.data_movimentacao).format('DD/MM/YYYY HH:mm')
          : '',
      }));
      setDados(dadosFormatados);
    } catch {
      toast.error('Erro ao buscar relatório.');
    }
  };

  const handleExportarExcel = () => {
    if (!dados.length) {
      toast.warning('Nenhum dado para exportar.');
      return;
    }
    toast.info('Exportação em desenvolvimento.');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'geral':
        return (
          <>
            <Card className="mb-3">
              <Card.Body className="py-3 px-3">
                <Row className="align-items-end g-2">
                  <Col xs={12} md>
                    <Form.Label
                      className="mb-1"
                      style={{ fontSize: '13px', fontWeight: 600 }}
                    >
                      Período
                    </Form.Label>
                    <Row className="g-2">
                      <Col xs={6}>
                        <div className="position-relative">
                          <MaskedInput
                            mask={MASK_DATE}
                            className="form-control"
                            placeholder="__/__/____"
                            value={dataInicial}
                            onChange={e => setDataInicial(e.target.value)}
                            style={{ paddingRight: '35px' }}
                          />
                          <div
                            className="position-absolute d-flex align-items-center"
                            style={{
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                            }}
                          >
                            <FaCalendarAlt
                              className="text-secondary"
                              style={{ cursor: 'pointer' }}
                              onClick={() => setOpenPickerInicial(true)}
                            />
                          </div>
                          <MuiPickersUtilsProvider
                            utils={MomentUtils}
                            locale="pt-br"
                          >
                            <DatePicker
                              open={openPickerInicial}
                              onOpen={() => setOpenPickerInicial(true)}
                              onClose={() => setOpenPickerInicial(false)}
                              value={
                                dataInicial
                                  ? moment(dataInicial, 'DD/MM/YYYY')
                                  : null
                              }
                              onChange={date => {
                                setDataInicial(
                                  date ? date.format('DD/MM/YYYY') : ''
                                );
                                setOpenPickerInicial(false);
                              }}
                              format="DD/MM/YYYY"
                              TextFieldComponent={() => null}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="position-relative">
                          <MaskedInput
                            mask={MASK_DATE}
                            className="form-control"
                            placeholder="__/__/____"
                            value={dataFinal}
                            onChange={e => setDataFinal(e.target.value)}
                            style={{ paddingRight: '35px' }}
                          />
                          <div
                            className="position-absolute d-flex align-items-center"
                            style={{
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                            }}
                          >
                            <FaCalendarAlt
                              className="text-secondary"
                              style={{ cursor: 'pointer' }}
                              onClick={() => setOpenPickerFinal(true)}
                            />
                          </div>
                          <MuiPickersUtilsProvider
                            utils={MomentUtils}
                            locale="pt-br"
                          >
                            <DatePicker
                              open={openPickerFinal}
                              onOpen={() => setOpenPickerFinal(true)}
                              onClose={() => setOpenPickerFinal(false)}
                              value={
                                dataFinal
                                  ? moment(dataFinal, 'DD/MM/YYYY')
                                  : null
                              }
                              onChange={date => {
                                setDataFinal(
                                  date ? date.format('DD/MM/YYYY') : ''
                                );
                                setOpenPickerFinal(false);
                              }}
                              format="DD/MM/YYYY"
                              TextFieldComponent={() => null}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} md>
                    <Form.Label
                      className="mb-1"
                      style={{ fontSize: '13px', fontWeight: 600 }}
                    >
                      Movimentação
                    </Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      placeholder="Selecione..."
                      options={MOVIMENTACAO_OPTIONS}
                      value={movimentacao}
                      onChange={selected => setMovimentacao(selected || [])}
                      isMulti
                      isClearable
                      noOptionsMessage={() => 'Nenhuma opção'}
                    />
                  </Col>
                  <Col xs={12} md>
                    <Form.Label
                      className="mb-1"
                      style={{ fontSize: '13px', fontWeight: 600 }}
                    >
                      Configurações
                    </Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      placeholder="Selecione..."
                      options={CONFIGURACAO_OPTIONS}
                      value={configuracao}
                      onChange={setConfiguracao}
                      isClearable
                      noOptionsMessage={() => 'Nenhuma opção'}
                    />
                  </Col>
                  <Col xs={12} md>
                    <Form.Label
                      className="mb-1"
                      style={{ fontSize: '13px', fontWeight: 600 }}
                    >
                      Usuário
                    </Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      placeholder="Selecione..."
                      options={opcoesUsuario}
                      value={usuario}
                      onChange={setUsuario}
                      isClearable
                      noOptionsMessage={() => 'Nenhum usuário'}
                    />
                  </Col>
                  <Col xs={12} md="auto" className="d-flex">
                    <Button
                      variant="outline-secondary"
                      onClick={handleLimparFiltros}
                      className="d-flex align-items-center mr-1"
                    >
                      <FaTimes />
                      <span>Limpar Filtros</span>
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleBuscar}
                      className="d-flex align-items-center gap-1"
                    >
                      <FaSearch />
                      <span>Buscar</span>
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Tabela
              colunas={colunas}
              dados={dados}
              fontSize="13px"
            />
            <div className="mt-3">
              <Button
                variant="success"
                size="sm"
                onClick={handleExportarExcel}
                className="d-flex align-items-center gap-1"
              >
                <FaFileExcel />
                <span>Extrair Excel</span>
              </Button>
            </div>
          </>
        );
      case 'entregues':
        return <Entregues />;
      case 'clientes':
        return <Clientes />;
      case 'estoque':
        return <Estoque />;
      case 'configuracoes':
        return <Configuracoes />;
      default:
        return null;
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul
        title="Controle de Brindes"
        contemTabs
        tabs={getTabs()}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      {renderTabContent()}
    </Container>
  );
};

export default ControleBrindes;
